// Gatsby requirements
import React from 'react'
import { storyblokEditable } from "gatsby-source-storyblok";

// Components
import RichText from "utils/RichTextRenderer"
import Button from "components/Button/Button"

// Styles
import * as CSS from './PricingCards.module.scss'


const PricingCards = ({ data }) => {

    return (
        <section
            className={`
                ${CSS.section}
                ${'section' + data._uid}
            `}
            style={{backgroundColor: data?.backgroundColor}}
            {...storyblokEditable(data)}
        >

            {data?.css &&
                <style dangerouslySetInnerHTML={{__html:
                    data.css.replaceAll('.section', '.section' + data._uid)
                        .replaceAll('.top-text', '.top-text' + data._uid)
                        .replaceAll('.card', '.card' + data._uid)
                        .replaceAll('.text-under', '.text-under' + data._uid)
                }} />
            }

            <div className={CSS.wrapper}>
                {data?.richText &&
                    <div className={`${CSS.richText} ${'top-text' + data._uid}`}>
                        <RichText content={data?.richText} />
                    </div>
                }
                <div className={CSS.cards}>
                    {data.cards.map((loop, i) => (
                        <div key={i} className={`${CSS.card} ${'card' + data._uid}`}>
                            <div className={CSS.leftSide}>
                                {loop.centeredText && <RichText content={loop.centeredText} /> }
                            </div>
                            <div className={CSS.rightSide}>
                                <div className={CSS.rightSideTop}>
                                    <p className={`${CSS.price} ${loop?.priceIsMonthly ? CSS.priceMonthly : ''}`}>
                                        <b>{loop.firstPrice}</b>
                                        {loop?.priceIsMonthly &&
                                            <span>/ month</span>
                                        }
                                    </p>
                                    <div className={CSS.topRightRichtext}>
                                        <RichText content={loop?.firstPriceRichtext} />
                                    </div>
                                </div>
                                <div className={CSS.rightSideBottom}>
                                    {loop?.button && loop.button.map((button, i) => (
                                        <Button key={i} data={button} insertClass="button" />
                                    ))}
                                    <RichText content={loop?.centeredTextUnderButton} />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                {data?.textUnderCards &&
                    <div className={`${CSS.bottomRichText} ${'text-under' + data._uid}`}>
                        <RichText content={data?.textUnderCards} />
                    </div>
                }
            </div>
        </section>
    )
}

export default PricingCards